import { batch } from 'react-redux';

import { store,modifyDisplaymodal ,modifyQualiflead} from '../state/redux';
import { addEltHistory } from '../state/reactquery';

import { axios_gestion_fauxnumero } from '../axios/axios_gestion';

import { modifyonelead } from './actions_lead';
import { progressions_contact,progressions_devisenvoye,progressions_attentedocuments,
        progressions_attentesignature} from './listeprogression';

export const modifystatus_fauxnum= ()=>{
    const lead = store.getState().lead.leadactu;
    axios_gestion_fauxnumero({'email': lead.email, 'telephone': lead.telephone,
                            'date_origine':lead.date_origine ,'courtier': lead.courtier, 
                            'origine':lead.origine,'campagne':lead.campagne,
                            'commercial':lead.commercial });
    addEltHistory(lead.id,'qualiflead', `<div class='horoline1' >Qualification du prospect en <span class='horobold'>Faux numéro</span>  </div>`) ;

    batch( () => {  store.dispatch(modifyQualiflead(true));
                    store.dispatch(modifyDisplaymodal(null));
                    modifyonelead({'statut_client': 'echec_fauxnum'}) ;});
                    
}

function decalagehoraire(){
        const heureLocale = (new Date()).getHours();
        const heureFranceStr = new Intl.DateTimeFormat('fr-FR', {timeZone: 'Europe/Paris',hour: 'numeric',hour12: false}).format(new Date());
        const heureFrance = parseInt(heureFranceStr, 10);

        return heureLocale - heureFrance  ;
}

export const modifystatus_nrp= ()=>{
    const lead = store.getState().lead.leadactu;
    const heureactu =lead.date_rdvrelance ? (new Date(lead.date_rdvrelance)).getUTCHours(): (new Date().getUTCHours())+decalagehoraire();
    const heurenew = heureactu<16? heureactu+4: 10 ;   
    let demain =(new Date((new Date().getTime()+24*60*60*1000))).toISOString()?.split('T')[0]+'T'+heurenew+':00:00.443Z';

    const newstatutclient = lead.statut_client?.includes('gagne')? lead.statut_client : 
                            ( progressions_contact.includes(lead.statut_client)?'contact_nrp':progressions_devisenvoye.includes(lead.statut_client)?'devisenvoye_nrp':
                        progressions_attentedocuments.includes(lead.statut_client)?'attente_documents_nrp':progressions_attentesignature.includes(lead.statut_client)?'attente_signature_nrp':'contact_nrp');  

        addEltHistory(lead.id,'qualiflead', `<div class='horoline1' >Qualification du prospect en <span className=horobold'>Ne répond pas</span> </div>`) 
        batch( () => { store.dispatch(modifyQualiflead(true));
                        store.dispatch(modifyDisplaymodal(null));
                        modifyonelead({ 'date_rdvrelance':demain, 'statut_client':newstatutclient });
                        });            
  
}
